import React, { useState } from "react";
import { useEffect } from "react";

const Tempapp = () => {
  const [city, setCity] = useState(null); //for storing the city name
  const [search, setSearch] = useState(null); //for storing the searched data of city
  useEffect(() => {
    const fetchApi = async () => {
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${search}&units=metric&appid=416aaf5254d51e8853767a4818be0f9f`; //api of weather
      const response = await fetch(url); //fetching the data
      const resJson = await response.json(); //convering it into json format
      setCity(resJson.main); //updating the data into setcity but only the main data will be stored
    };
    fetchApi(); //calling the fetch api fuction
  }, [search]); //to avoid reload of whole page

  return (
    <div className=" flex h-screen bg-[url(https://i.ibb.co/C09XZLy/image-processing20190801-4-1x8wkd2.jpg)] bg-cover justify-center text-black ">
      <div className="box flex flex-col w-[24rem] bg-white opacity-60 rounded-3xl  h-[28rem] mt-[12rem] ">
        <div className="inputData    ">
          <input
            type="search"
            value={search}
            placeholder="Enter the city"
            className="inputField w-[18rem] h-[3rem] mx-[4rem] rounded-3xl text-center text-2xl mt-[3rem] border border-black  font-bold   "
            onChange={(event) => {
              setSearch(event.target.value); //updates the search data value by targetting it
            }}
          />
        </div>
        {!city ? (
          <p className="errorMsg text-center text-2xl py-6">No data found</p> //simple ternary operator if the city name doesnot exits error msg
        ) : (
          <div>
            <div className="info">
              <h2 className="location text-[4rem]  text-center py-9 flex flex-wrap justify-center">
                <img
                  src="https://i.ibb.co/MS170j1/location-icon-vector.jpg"
                  className="w-[5rem] flex"
                  alt=""
                />{" "}
                {search}
              </h2>
              <h1 className="temp text-center text-4xl font-bold">
                {city.temp} °C{" "}
              </h1>
              <h3 className="tempmin_max text-center font-semibold text-2xl py-6">
                Min : {city.temp_min} °C | Max : {city.temp_max} °C
              </h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Tempapp;
